export const dimensionsFormatter = (value) => {
  const formattedValue = `${value} cm`;

  return formattedValue;
};
